import { Route, Routes } from "react-router-dom"
import Products from "./Products"
import ProductDetail from "./ProductDetail"
import EditProduct from "./EditProduct"

const Inventory = () => {

    return (
        <Routes>
            <Route element={<Products />} path="/" />
            <Route element={<ProductDetail />} path="/detail/:productId" />
            <Route element={<EditProduct />} path="/edit/:productId" />
        </Routes>
    )
}

export default Inventory